import React from 'react';

const ProfileHeader = () => (
  <div className="container">
    <div className="profile-header">
      <div className="profile-content">
        <div className="profile-avatar">
          <img 
            src="/profile.jpg" 
            alt="vita" 
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        </div>
        <div className="profile-info">
          <div className="profile-name">VITA</div>
          <div className="profile-desc">Les meilleurs bonus casinos sélectionnés par Vita</div>
        </div>
      </div>
    </div>
  </div>
);

export default ProfileHeader;



